import { Type } from 'class-transformer';
import { BaseEntity } from '@models';
import { AssesmentQuestion } from '@services/assesment';
import { ParkAreaAssesment } from '@services/park-area-assesment';

export class ParkAreaAssesmentAnswer extends BaseEntity {
	parkAreaAssesmentId: string;

	// @Type(() => ParkAreaAssesment) // circular dependency
	parkAreaAssesment: ParkAreaAssesment;

	assesmentQuestionId: string;

	@Type(() => AssesmentQuestion)
	assesmentQuestion: AssesmentQuestion;

	answer: string[];
}
